import './About.css';
import { useRef, useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';
import CountUp from '../CountUp/CountUp';

// Regjistro ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

function useInView(ref, options = {}) {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      options
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, options]);
  return inView;
}

function About() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const statsRef = useRef([]);
  const inView = useInView(sectionRef);

  useEffect(() => {
    const stats = statsRef.current;
    
    // Vendos gjendjen fillestare të fshehur
    gsap.set(stats, {
      opacity: 0,
      y: 30,
      scale: 0.9
    });

    // Krijo timeline për animacionet
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 80%",
        end: "bottom 20%",
        scrub: 1,
        toggleActions: "play none none reverse"
      }
    });

    // Shto animacionet për secilën statistikë
    stats.forEach((stat, index) => {
      tl.to(stat, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "back.out(1.7)"
      }, index * 0.2);
    });

    // Pastro animacionet kur komponenti çmontohet
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section 
      className="about-section" 
      id="about" 
      ref={sectionRef}
      style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)), url(${process.env.PUBLIC_URL}/images/accounting-bg.webp)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="about-content">
        <h2>{t('about.title')}</h2>
        <p>{t('about.desc')}</p>
        
        <div className="about-stats">
          <div 
            className="stat-box"
            ref={el => statsRef.current[0] = el}
          >
            <div className="stat-value">
              <CountUp end={100} startWhen={inView} suffix="%" />
            </div>
            <div className="stat-label">{t('about.stat1')}</div>
          </div>
          
          <div 
            className="stat-box"
            ref={el => statsRef.current[1] = el}
          >
            <div className="stat-value">
              <CountUp end={30} startWhen={inView} suffix="+" />
            </div>
            <div className="stat-label">{t('about.stat2')}</div>
          </div>
          
          <div 
            className="stat-box"
            ref={el => statsRef.current[2] = el}
          >
            <div className="stat-value">
              <CountUp end={120} startWhen={inView} suffix="+" />
            </div>
            <div className="stat-label">{t('about.stat3')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About; 